import { render } from "./Platforms.vue?vue&type=template&id=04d5f3a6"
import script from "./Platforms.vue?vue&type=script&lang=js"
export * from "./Platforms.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__